import React from 'react';
import styled from 'styled-components';
import Toggle from 'material-ui/Toggle';
import colors from '@theme/colors';

const toggleStyle = {
  general: {
    marginBottom: 0,
    paddingBottom: '22px',
  },
  label: {
    color: colors.TEAL_LIGHT,
    fontSize: 15,
    fontWeight: 500,
    fontFamily: 'Lato, sans-serif',
    width: 'calc(100% - 70px)',
  },
  thumbOff: {
    backgroundColor: colors.LIGHT_GREY,
    top: '6px',
    left: '2px',
  },
  trackOff: {
    backgroundColor: colors.TEAL_INTENSIVE,
    height: '23px',
    minWidth: '45px',
    border: `1px solid ${colors.LIGHT_GREY}`,
  },
  thumbSwitched: {
    backgroundColor: colors.TEAL_INTENSIVE,
    top: '6px',
    left: '46px',
  },
  trackSwitched: {
    backgroundColor: colors.LIGHT_GREY,
  },
  thumbSwitchedText: {
    position: 'absolute',
    top: '3px',
    left: '100%',
    margin: '0 0 0 -57px',
    lineHeight: '24px',
    fontSize: '12px',
    fontWeight: 500,
    color: colors.TEAL_INTENSIVE,
  },
};

export const ToggleWrapper = styled.div`
  position: relative;
`;

const StyledToggle = (props) => {
  return (
    <ToggleWrapper>
      <Toggle
        style={toggleStyle.general}
        labelStyle={toggleStyle.label}
        thumbStyle={toggleStyle.thumbOff}
        trackStyle={toggleStyle.trackOff}
        thumbSwitchedStyle={toggleStyle.thumbSwitched}
        trackSwitchedStyle={toggleStyle.trackSwitched}
        {...props}
      />
      {props.toggled ? <span style={toggleStyle.thumbSwitchedText}>On</span> : null}
    </ToggleWrapper>
  );
};

export default StyledToggle;



// WEBPACK FOOTER //
// ./components/atoms/Toggle.js